import React from 'react';

const XtLoading: React.FC<any> = ({ ...restProps }) => (
  <div className="xt-loading" {...restProps}>
    <div className="line-scale">
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default XtLoading;
